import { API_URL } from "../components/common/Config";

let cachedSettings = undefined;
let inflightPromise = null;

export function clearCompanySettingsCache() {
  cachedSettings = undefined;
  inflightPromise = null;
}

export function resolveCustomerApiEncrypt(settings) {
  if (settings === null || settings === undefined) {
    return true;
  }
  return String(settings.is_encrypt ?? "").toLowerCase() === "yes";
}

export async function getCompanySettings() {
  if (cachedSettings !== undefined) {
    return cachedSettings;
  }
  if (!inflightPromise) {
    inflightPromise = (async () => {
      try {
        const authToken = localStorage.getItem("token");
        if (!authToken) {
          cachedSettings = null;
          return null;
        }
        const response = await fetch(`${API_URL}/settings/ws-get-company-settings`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        const result = await response.json();
        cachedSettings = result?.data ?? null;
        return cachedSettings;
      } catch {
        cachedSettings = null;
        return null;
      } finally {
        inflightPromise = null;
      }
    })();
  }
  return inflightPromise;
}

export function resolveIsPriceEditable(settings) {
  if (settings === null || settings === undefined) {
    return true;
  }
  return settings.is_price_editable === "Y";
}

export function resolveCheckStockBeforeAddToCart(settings) {
  if (settings === null || settings === undefined) {
    return true;
  }
  return settings.checkStockBeforeAddToCart !== "N";
}

/** When false (displayProductStock N / 0), stock limits should not be enforced in sales UI. */
export function resolveDisplayProductStock(settings) {
  if (settings === null || settings === undefined) {
    return true;
  }
  const value = String(settings.displayProductStock ?? "").trim().toUpperCase();
  if (value === "N" || value === "0" || value === "NO" || value === "FALSE") {
    return false;
  }
  return true;
}
